import { render } from "./EventRegPayment.vue?vue&type=template&id=e3898224&scoped=true"
import script from "./EventRegPayment.vue?vue&type=script&lang=js"
export * from "./EventRegPayment.vue?vue&type=script&lang=js"

import "./EventRegPayment.vue?vue&type=style&index=0&id=e3898224&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3898224"]])

export default __exports__